import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';

// Add global error handler for production
if (process.env.NODE_ENV === 'production') {
  window.addEventListener('error', (event) => {
    console.error('Global error:', event.error);
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
  });
}

const fallback = (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-10 w-10 border-4 border-[#62329f] border-t-transparent"></div>
  </div>
);

const appTree = (
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense fallback={fallback}>
        <App />
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);

const rootElement = document.getElementById('root');

// Use hydrateRoot if react-snap has pre-rendered the page
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, appTree);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(appTree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
